import React from 'react';
import styled from 'styled-components';
import { height, isPortrait } from '../../utils/size';
import PropTypes from 'prop-types';

const calculateDonationButtonHeight = portraitMode => {
    const wrapper = document.getElementById('DonationWrapper');
    if (!wrapper) {
        return 88;
    }
    const availableSpace = portraitMode
        ? (height() - wrapper.offsetTop - 40) / 2
        : (height() - wrapper.offsetTop - 40) / 1;
    return availableSpace * 0.85 > 88 ? 88 : availableSpace * 0.85;
};

const Amount = styled.div`
    align-items: center;
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    color: #333;
    display: flex;
    font-size: 2em;
    font-weight: 300;
    justify-content: center;
    line-height: 0.69;
    flex: 0 50%;
    height: ${() => calculateDonationButtonHeight(isPortrait())}px;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 1);

    @media (min-width: 30.0625em) {
        max-width: 184px;
        &:hover {
            cursor: pointer;
            color: white;
            background-color: #ff245e;
            border-color: #ff245e;
        }
    }

    @media (max-width: 30em) {
        width: calc(50% - 0.25em);
        flex: none;
    }
`;

const MostPopularAmount = Amount.extend`
    border-radius: 4px;
    background-color: #fff;
    border: solid 4px #ff245e;
    position: relative;

    @media (min-width: 30.0625em) {
        &:hover {
            border: solid 4px #ff245e;
        }
    }
`;

const MostPopular = styled.div`
    font-size: 0.25em;
    font-family: Lato;
    font-weight: 900;
    line-height: 1.3;
    letter-spacing: 1px;
    color: #fff;
    background-color: #ff245e;
    border-radius: 12px;
    position: absolute;
    padding: 0.3em 1em 0.35em;
    bottom: -1.15em;
    left: 0;
    right: 0;
    margin: 0 2em;
    display: flex;
    justify-content: center;
    text-align: center;

    @media (max-width: 30em) {
        margin: 0 15%;
    }
    @media (max-width: 24em) {
        margin: 0 10%;
        font-size: 0.2em;
    }
`;

const DonationAmount = props =>
    props.isMostPopular ? (
        <MostPopularAmount onClick={props.onSelectAmount}>
            ${props.amount}
            <MostPopular>MOST POPULAR</MostPopular>
        </MostPopularAmount>
    ) : (
        <Amount onClick={props.onSelectAmount}>
            {props.amount ? '$' + props.amount : 'Other'}
        </Amount>
    );

DonationAmount.propTypes = {
    amount: PropTypes.number.isRequired,
    isMostPopular: PropTypes.bool.isRequired,
    onSelectAmount: PropTypes.func.isRequired
};

export default DonationAmount;



// WEBPACK FOOTER //
// ./src/components/Donation/DonationAmount.jsx